(() => {
  'use strict';
  const number = (node, key, integer = false) => {
    const raw = node?.getAttribute(key);
    if (raw === null || raw === undefined || !/^\d+(?:\.\d+)?$/.test(raw.trim())) return null;
    const value = Number(raw);
    return Number.isFinite(value) && value >= 0 && (!integer || Number.isInteger(value)) ? value : null;
  };
  const put = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const init = (root) => {
    if (root.dataset.reviewBound) return;
    root.dataset.reviewBound = 'true';
    const copy = root.querySelector('[data-review-copy]')?.dataset || {};
    let pending = false, fitPending = false;
    const fitRail = () => {
      fitPending = false;
      const rail = root.querySelector('.jdgm-carousel__item-container');
      if (!rail || rail.clientWidth === 0) return;
      const bounds = rail.getBoundingClientRect();
      let tallest = 0;
      rail.querySelectorAll('.jdgm-carousel-item').forEach(card => {
        const box = card.getBoundingClientRect();
        if (box.right > bounds.left + 1 && box.left < bounds.right - 1) tallest = Math.max(tallest, box.height);
      });
      if (!tallest) { rail.style.removeProperty('height'); return; }
      const style = getComputedStyle(rail);
      const border = (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.borderBottomWidth) || 0);
      const scrollbar = Math.max(0, rail.offsetHeight - rail.clientHeight - border);
      const height = Math.ceil(tallest + (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0) + border + scrollbar) + 'px';
      if (rail.style.height !== height) rail.style.setProperty('height', height, 'important');
    };
    const queueFit = () => { if (!fitPending) { fitPending = true; requestAnimationFrame(fitRail); } };
    const refresh = () => {
      pending = false;
      const count = number(root.querySelector('.jdgm-carousel-number-of-reviews[data-number-of-reviews]'), 'data-number-of-reviews', true);
      const score = number(root.querySelector('.jdgm-all-reviews-rating[data-score]'), 'data-score');
      const verified = number(root.querySelector('.jdgm-medals-wrapper .jdgm-rating__count[data-value]'), 'data-value', true);
      const valid = count !== null && score !== null && score <= 5;
      root.classList.toggle('fs-reviews--ready', valid);
      root.querySelector('[data-review-summary]').hidden = !valid;
      if (valid) {
        put(root.querySelector('[data-review-count]'), count.toLocaleString(document.documentElement.lang || 'en'));
        put(root.querySelector('[data-review-score]'), String(score));
        const stars = root.querySelector('[data-review-stars]');
        stars.style.setProperty('--review-fill', `${score / 5 * 100}%`);
        const verifiedRow = root.querySelector('[data-review-verified-row]');
        verifiedRow.hidden = verified === null || verified > count;
        if (!verifiedRow.hidden) put(root.querySelector('[data-review-verified]'), verified.toLocaleString(document.documentElement.lang || 'en'));
      }
      const rail = root.querySelector('.jdgm-carousel__item-container');
      const cards = root.querySelectorAll('.jdgm-carousel-item');
      root.querySelector('[data-review-nav]').hidden = !rail || cards.length < 2;
      if (rail && !rail.dataset.fsHeightBound) { rail.dataset.fsHeightBound = 'true'; rail.addEventListener('scroll', queueFit, {passive:true}); }
      if (rail) { rail.tabIndex = 0; rail.setAttribute('role', 'region'); rail.setAttribute('aria-label', copy.scrollLabel || 'Customer reviews'); }
      cards.forEach((card) => {
        const img = card.querySelector('.jdgm-carousel-item__product-image');
        if (img) {
          img.loading = 'lazy'; img.decoding = 'async';
          const src = img.getAttribute('data-src');
          if (!img.getAttribute('src') && src && /^https:\/\//.test(src)) img.setAttribute('src', src);
        }
        const title = card.querySelector('.jdgm-carousel-item__review-title');
        const body = card.querySelector('.jdgm-carousel-item__review-body');
        const clipped = [title, body].some(node => node && node.scrollHeight > node.clientHeight + 1);
        const lengthy = (title?.textContent.trim().length || 0) > 55 || (body?.textContent.trim().length || 0) > 135;
        if ((clipped || lengthy) && !card.querySelector('.fs-reviews__expand')) {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'fs-reviews__expand';
          button.setAttribute('aria-expanded', 'false'); button.textContent = copy.expand || 'Read full review';
          button.addEventListener('click', () => {
            const expand = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(expand)); card.dataset.reviewExpanded = String(expand);
            button.textContent = expand ? (copy.collapse || 'Show less') : (copy.expand || 'Read full review');
            queue();
          });
          card.querySelector('.jdgm-carousel-item__review-content')?.append(button);
        }
      });
      fitRail();
    };
    const queue = () => { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
    const observer = new MutationObserver(queue);
    observer.observe(root, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews','data-score','data-value']});
    const resizer = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
    resizer?.observe(root);
    document.fonts?.ready.then(queue);
    root.addEventListener('load', queue, true);
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-direction]');
      if (!button || !root.contains(button)) return;
      const rail = root.querySelector('.jdgm-carousel__item-container');
      const card = rail?.querySelector('.jdgm-carousel-item');
      if (rail && card) rail.scrollBy({left:Number(button.dataset.reviewDirection) * (card.getBoundingClientRect().width + 12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
    root.addEventListener('keydown', (event) => {
      const rail = root.querySelector('.jdgm-carousel__item-container');
      if (event.target !== rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? rail.scrollWidth : rail.scrollLeft + (event.key === 'ArrowLeft' ? -1 : 1) * (rail.querySelector('.jdgm-carousel-item')?.getBoundingClientRect().width + 12 || 260);
      rail.scrollTo({left:target,behavior:'auto'});
    });
    refresh();
    document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(root)) { observer.disconnect(); resizer?.disconnect(); } });
  };
  document.querySelectorAll('[data-fs-home-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-fs-home-reviews]').forEach(init));
})();
